@if (drawingPoints.length === 0) {
  <div
    class="typo-h4-light pointer-events-none col-start-1 row-start-1 select-none place-self-center text-text-light"
    [ngClass]="{ '!text-text-extra-light': isDisabled }"
  >
    {{ 'charting_treatment_plan_review_treatment_review_sign_here' | translate }}
  </div>
}
<canvas
  #canvas
  class="col-start-1 row-start-1 h-full w-full"
  [ngClass]="{ 'pointer-events-none': isDisabled }"
  (mousedown)="onMouseDownOnCanvas($event)"
  (mousemove)="onMouseMoveOnCanvas($event)"
  (mouseup)="onMouseUpOnCanvas($event)"
  (mouseleave)="onMouseLeaveCanvas($event)"
></canvas>
<button
  type="button"
  class="typo-h4-semibold col-start-1 row-start-1 self-start justify-self-end text-primary-blue disabled:text-text-extra-light"
  (click)="onClearClick()"
  [disabled]="isDisabled"
>
  {{ 'charting_treatment_plan_review_treatment_review_sign_clear' | translate }}
</button>
